import { Logger } from '~/shared/logger'

export const logger = new Logger('tria/mq')
